export enum DiscountPermissions {
  Vendor = 'discounts:manage:vendor',
  Seller = 'discounts:manage:seller',
  All = 'discounts:manage:all',
}

export const discountPermissions = Object.values(DiscountPermissions)
